(() => {
    HuiNavHeadController.$inject = ['$scope', '$element', '$timeout' , '$filter'];

    function HuiNavHeadController($scope, $element, $timeout, $filter) {
        const self = this;

        self.$onInit = () => {
            self.searchPlaceholder = self.searchPlaceholder || $filter('translate')(`Find an item`);
        };

        self.$onChanges = (changeObj) => {
            if (changeObj.showInput?.previousValue !== changeObj.showInput?.currentValue) {
                if (self.showInput) {
                    $timeout(() => {
                        $element?.find('input').focus();
                    });
                }
            }
        }
    }

    angular
        .module("harriApp")
        .directive("huiNavHead", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                bindToController: {
                    label: '<',
                    showInput: '<',
                    searchEnabled: '<',
                    searchPlaceholder: '<',
                    onToggleSearch: '&',
                    onFilterItems: '&',
                    searchTerm: '=',
                    showBackArrow: '<',
                    onBackArrowClick: '&',
                    open: '<',
                    icon: '<',
                },
                controllerAs: '$ctrl',
                controller: HuiNavHeadController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav-head.html`
            }
        });

})();